import { DashboardNoSpenderListRestEndpointService } from '@api'
import { useMutation, useQueryClient } from 'react-query'

import { useToast } from '@/components/ui/toast'
import { handleError } from '@/utils/error'

export function useNoSpenderListMutations(creatorId: number) {
  const toast = useToast()
  const queryClient = useQueryClient()

  const createNoSpenderList = useMutation({
    mutationFn: (variables: { name: string; days: number }) =>
      DashboardNoSpenderListRestEndpointService.dashboardCreateNoSpenderList({
        creatorId,
        requestBody: {
          name: variables.name,
          days: variables.days,
        },
      }),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['creator', creatorId, 'no-spenders'],
      })

      toast.success(`List "${variables.name}" created successfully`)
    },
    onError: (error) => {
      handleError(error, 'Failed to create no spender list')
    },
  })

  const updateNoSpenderList = useMutation({
    mutationFn: (variables: { id: number; name: string; days: number }) =>
      DashboardNoSpenderListRestEndpointService.dashboardUpdateNoSpenderList({
        creatorId,
        listId: variables.id,
        requestBody: {
          name: variables.name,
          days: variables.days,
        },
      }),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['creator', creatorId, 'no-spenders'],
      })

      toast.success(`List "${variables.name}" updated successfully`)
    },
    onError: (error) => {
      handleError(error, 'Failed to update no spender list')
    },
  })

  const deleteNoSpenderList = useMutation({
    mutationFn: (listId: number) =>
      DashboardNoSpenderListRestEndpointService.dashboardDeleteNoSpenderList({
        creatorId,
        listId,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['creator', creatorId, 'no-spenders'],
      })

      toast.success('List deleted successfully')
    },
    onError: (error) => {
      handleError(error, 'Failed to delete no spender list')
    },
  })

  return { createNoSpenderList, updateNoSpenderList, deleteNoSpenderList }
}
